/**
 * 格式化 Date 对象
 * @example formateDateTime(1679110722000, 'yyyy年MM-dd日')
 */
export function formateDateTime(date, fmt='yyyy-MM-dd hh:mm:ss') {
  if (!date) {
    return ''
  }
  date = new Date(date)
  const _ = {
    'M+': date.getMonth()+1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    S: date.getMilliseconds()
  }

  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  for (const k in _) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1,  RegExp.$1.length === 1 ? _[k] : ('00' + _[k]).substr(('' + _[k]).length))
    }
  }

  return fmt
}